/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as AttachmentTypesRouteImport } from './routes/attachment-types'
import { Route as CatalogueRouteImport } from './routes/catalogue'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as CurrenciesRouteImport } from './routes/currencies'
import { Route as FootprintsRouteImport } from './routes/footprints'
import { Route as ImportExportRouteImport } from './routes/import-export'
import { Route as LabelsRouteImport } from './routes/labels'
import { Route as LocationsRouteImport } from './routes/locations'
import { Route as ManufacturersRouteImport } from './routes/manufacturers'
import { Route as PreferencesRouteImport } from './routes/preferences'
import { Route as ProvidersRouteImport } from './routes/providers'
import { Route as ScanRouteImport } from './routes/scan'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ShelfRouteImport } from './routes/shelf'
import { Route as SuppliersRouteImport } from './routes/suppliers'
import { Route as UnitsRouteImport } from './routes/units'
import { Route as CatalogueIndexRouteImport } from './routes/catalogue.index'
import { Route as CatalogueKindRouteImport } from './routes/catalogue.$kind'
import { Route as LocationsIndexRouteImport } from './routes/locations.index'
import { Route as LocationsLocationIdRouteImport } from './routes/locations.$locationId'
import { Route as LocationsManageRouteImport } from './routes/locations.manage'
import { Route as PartsIndexRouteImport } from './routes/parts.index'
import { Route as PartsNewRouteImport } from './routes/parts.new'
import { Route as ProjectsIndexRouteImport } from './routes/projects.index'
import { Route as ShelfIndexRouteImport } from './routes/shelf.index'
import { Route as ShelfRecentRouteImport } from './routes/shelf.recent'
import { Route as ShelfScanRouteImport } from './routes/shelf.scan'
import { Route as PartsPartIdIndexRouteImport } from './routes/parts.$partId.index'
import { Route as PartsPartIdEditRouteImport } from './routes/parts.$partId.edit'
import { Route as ProjectsProjectIdIndexRouteImport } from './routes/projects.$projectId.index'
import { Route as ProjectsProjectIdAssemblyRouteImport } from './routes/projects.$projectId.assembly'
import { Route as ShelfDrawerLocationIdRouteImport } from './routes/shelf.drawer.$locationId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const AttachmentTypesRoute = AttachmentTypesRouteImport.update({
  id: '/attachment-types',
  path: '/attachment-types',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogueRoute = CatalogueRouteImport.update({
  id: '/catalogue',
  path: '/catalogue',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoriesRoute = CategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const CurrenciesRoute = CurrenciesRouteImport.update({
  id: '/currencies',
  path: '/currencies',
  getParentRoute: () => rootRouteImport,
} as any)
const FootprintsRoute = FootprintsRouteImport.update({
  id: '/footprints',
  path: '/footprints',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportExportRoute = ImportExportRouteImport.update({
  id: '/import-export',
  path: '/import-export',
  getParentRoute: () => rootRouteImport,
} as any)
const LabelsRoute = LabelsRouteImport.update({
  id: '/labels',
  path: '/labels',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsRoute = LocationsRouteImport.update({
  id: '/locations',
  path: '/locations',
  getParentRoute: () => rootRouteImport,
} as any)
const ManufacturersRoute = ManufacturersRouteImport.update({
  id: '/manufacturers',
  path: '/manufacturers',
  getParentRoute: () => rootRouteImport,
} as any)
const PreferencesRoute = PreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => rootRouteImport,
} as any)
const ProvidersRoute = ProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => rootRouteImport,
} as any)
const ScanRoute = ScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ShelfRoute = ShelfRouteImport.update({
  id: '/shelf',
  path: '/shelf',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersRoute = SuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => rootRouteImport,
} as any)
const UnitsRoute = UnitsRouteImport.update({
  id: '/units',
  path: '/units',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogueIndexRoute = CatalogueIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CatalogueRoute,
} as any)
const CatalogueKindRoute = CatalogueKindRouteImport.update({
  id: '/$kind',
  path: '/$kind',
  getParentRoute: () => CatalogueRoute,
} as any)
const LocationsIndexRoute = LocationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocationsRoute,
} as any)
const LocationsLocationIdRoute = LocationsLocationIdRouteImport.update({
  id: '/$locationId',
  path: '/$locationId',
  getParentRoute: () => LocationsRoute,
} as any)
const LocationsManageRoute = LocationsManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => LocationsRoute,
} as any)
const PartsIndexRoute = PartsIndexRouteImport.update({
  id: '/parts/',
  path: '/parts/',
  getParentRoute: () => rootRouteImport,
} as any)
const PartsNewRoute = PartsNewRouteImport.update({
  id: '/parts/new',
  path: '/parts/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShelfIndexRoute = ShelfIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShelfRoute,
} as any)
const ShelfRecentRoute = ShelfRecentRouteImport.update({
  id: '/recent',
  path: '/recent',
  getParentRoute: () => ShelfRoute,
} as any)
const ShelfScanRoute = ShelfScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => ShelfRoute,
} as any)
const PartsPartIdIndexRoute = PartsPartIdIndexRouteImport.update({
  id: '/parts/$partId/',
  path: '/parts/$partId/',
  getParentRoute: () => rootRouteImport,
} as any)
const PartsPartIdEditRoute = PartsPartIdEditRouteImport.update({
  id: '/parts/$partId/edit',
  path: '/parts/$partId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdIndexRoute = ProjectsProjectIdIndexRouteImport.update({
  id: '/projects/$projectId/',
  path: '/projects/$projectId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdAssemblyRoute =
  ProjectsProjectIdAssemblyRouteImport.update({
    id: '/projects/$projectId/assembly',
    path: '/projects/$projectId/assembly',
    getParentRoute: () => rootRouteImport,
  } as any)
const ShelfDrawerLocationIdRoute = ShelfDrawerLocationIdRouteImport.update({
  id: '/drawer/$locationId',
  path: '/drawer/$locationId',
  getParentRoute: () => ShelfRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/attachment-types': typeof AttachmentTypesRoute
  '/catalogue': typeof CatalogueRouteWithChildren
  '/categories': typeof CategoriesRoute
  '/currencies': typeof CurrenciesRoute
  '/footprints': typeof FootprintsRoute
  '/import-export': typeof ImportExportRoute
  '/labels': typeof LabelsRoute
  '/locations': typeof LocationsRouteWithChildren
  '/manufacturers': typeof ManufacturersRoute
  '/preferences': typeof PreferencesRoute
  '/providers': typeof ProvidersRoute
  '/scan': typeof ScanRoute
  '/settings': typeof SettingsRoute
  '/shelf': typeof ShelfRouteWithChildren
  '/suppliers': typeof SuppliersRoute
  '/units': typeof UnitsRoute
  '/catalogue/$kind': typeof CatalogueKindRoute
  '/locations/$locationId': typeof LocationsLocationIdRoute
  '/locations/manage': typeof LocationsManageRoute
  '/parts/new': typeof PartsNewRoute
  '/shelf/recent': typeof ShelfRecentRoute
  '/shelf/scan': typeof ShelfScanRoute
  '/catalogue/': typeof CatalogueIndexRoute
  '/locations/': typeof LocationsIndexRoute
  '/parts/': typeof PartsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/shelf/': typeof ShelfIndexRoute
  '/parts/$partId/edit': typeof PartsPartIdEditRoute
  '/projects/$projectId/assembly': typeof ProjectsProjectIdAssemblyRoute
  '/shelf/drawer/$locationId': typeof ShelfDrawerLocationIdRoute
  '/parts/$partId/': typeof PartsPartIdIndexRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/attachment-types': typeof AttachmentTypesRoute
  '/categories': typeof CategoriesRoute
  '/currencies': typeof CurrenciesRoute
  '/footprints': typeof FootprintsRoute
  '/import-export': typeof ImportExportRoute
  '/labels': typeof LabelsRoute
  '/manufacturers': typeof ManufacturersRoute
  '/preferences': typeof PreferencesRoute
  '/providers': typeof ProvidersRoute
  '/scan': typeof ScanRoute
  '/settings': typeof SettingsRoute
  '/suppliers': typeof SuppliersRoute
  '/units': typeof UnitsRoute
  '/catalogue/$kind': typeof CatalogueKindRoute
  '/locations/$locationId': typeof LocationsLocationIdRoute
  '/locations/manage': typeof LocationsManageRoute
  '/parts/new': typeof PartsNewRoute
  '/shelf/recent': typeof ShelfRecentRoute
  '/shelf/scan': typeof ShelfScanRoute
  '/catalogue': typeof CatalogueIndexRoute
  '/locations': typeof LocationsIndexRoute
  '/parts': typeof PartsIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/shelf': typeof ShelfIndexRoute
  '/parts/$partId/edit': typeof PartsPartIdEditRoute
  '/projects/$projectId/assembly': typeof ProjectsProjectIdAssemblyRoute
  '/shelf/drawer/$locationId': typeof ShelfDrawerLocationIdRoute
  '/parts/$partId': typeof PartsPartIdIndexRoute
  '/projects/$projectId': typeof ProjectsProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/attachment-types': typeof AttachmentTypesRoute
  '/catalogue': typeof CatalogueRouteWithChildren
  '/categories': typeof CategoriesRoute
  '/currencies': typeof CurrenciesRoute
  '/footprints': typeof FootprintsRoute
  '/import-export': typeof ImportExportRoute
  '/labels': typeof LabelsRoute
  '/locations': typeof LocationsRouteWithChildren
  '/manufacturers': typeof ManufacturersRoute
  '/preferences': typeof PreferencesRoute
  '/providers': typeof ProvidersRoute
  '/scan': typeof ScanRoute
  '/settings': typeof SettingsRoute
  '/shelf': typeof ShelfRouteWithChildren
  '/suppliers': typeof SuppliersRoute
  '/units': typeof UnitsRoute
  '/catalogue/$kind': typeof CatalogueKindRoute
  '/locations/$locationId': typeof LocationsLocationIdRoute
  '/locations/manage': typeof LocationsManageRoute
  '/parts/new': typeof PartsNewRoute
  '/shelf/recent': typeof ShelfRecentRoute
  '/shelf/scan': typeof ShelfScanRoute
  '/catalogue/': typeof CatalogueIndexRoute
  '/locations/': typeof LocationsIndexRoute
  '/parts/': typeof PartsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/shelf/': typeof ShelfIndexRoute
  '/parts/$partId/edit': typeof PartsPartIdEditRoute
  '/projects/$projectId/assembly': typeof ProjectsProjectIdAssemblyRoute
  '/shelf/drawer/$locationId': typeof ShelfDrawerLocationIdRoute
  '/parts/$partId/': typeof PartsPartIdIndexRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/attachment-types'
    | '/catalogue'
    | '/categories'
    | '/currencies'
    | '/footprints'
    | '/import-export'
    | '/labels'
    | '/locations'
    | '/manufacturers'
    | '/preferences'
    | '/providers'
    | '/scan'
    | '/settings'
    | '/shelf'
    | '/suppliers'
    | '/units'
    | '/catalogue/$kind'
    | '/locations/$locationId'
    | '/locations/manage'
    | '/parts/new'
    | '/shelf/recent'
    | '/shelf/scan'
    | '/catalogue/'
    | '/locations/'
    | '/parts/'
    | '/projects/'
    | '/shelf/'
    | '/parts/$partId/edit'
    | '/projects/$projectId/assembly'
    | '/shelf/drawer/$locationId'
    | '/parts/$partId/'
    | '/projects/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/attachment-types'
    | '/categories'
    | '/currencies'
    | '/footprints'
    | '/import-export'
    | '/labels'
    | '/manufacturers'
    | '/preferences'
    | '/providers'
    | '/scan'
    | '/settings'
    | '/suppliers'
    | '/units'
    | '/catalogue/$kind'
    | '/locations/$locationId'
    | '/locations/manage'
    | '/parts/new'
    | '/shelf/recent'
    | '/shelf/scan'
    | '/catalogue'
    | '/locations'
    | '/parts'
    | '/projects'
    | '/shelf'
    | '/parts/$partId/edit'
    | '/projects/$projectId/assembly'
    | '/shelf/drawer/$locationId'
    | '/parts/$partId'
    | '/projects/$projectId'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/attachment-types'
    | '/catalogue'
    | '/categories'
    | '/currencies'
    | '/footprints'
    | '/import-export'
    | '/labels'
    | '/locations'
    | '/manufacturers'
    | '/preferences'
    | '/providers'
    | '/scan'
    | '/settings'
    | '/shelf'
    | '/suppliers'
    | '/units'
    | '/catalogue/$kind'
    | '/locations/$locationId'
    | '/locations/manage'
    | '/parts/new'
    | '/shelf/recent'
    | '/shelf/scan'
    | '/catalogue/'
    | '/locations/'
    | '/parts/'
    | '/projects/'
    | '/shelf/'
    | '/parts/$partId/edit'
    | '/projects/$projectId/assembly'
    | '/shelf/drawer/$locationId'
    | '/parts/$partId/'
    | '/projects/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  AttachmentTypesRoute: typeof AttachmentTypesRoute
  CatalogueRoute: typeof CatalogueRouteWithChildren
  CategoriesRoute: typeof CategoriesRoute
  CurrenciesRoute: typeof CurrenciesRoute
  FootprintsRoute: typeof FootprintsRoute
  ImportExportRoute: typeof ImportExportRoute
  LabelsRoute: typeof LabelsRoute
  LocationsRoute: typeof LocationsRouteWithChildren
  ManufacturersRoute: typeof ManufacturersRoute
  PreferencesRoute: typeof PreferencesRoute
  ProvidersRoute: typeof ProvidersRoute
  ScanRoute: typeof ScanRoute
  SettingsRoute: typeof SettingsRoute
  ShelfRoute: typeof ShelfRouteWithChildren
  SuppliersRoute: typeof SuppliersRoute
  UnitsRoute: typeof UnitsRoute
  PartsNewRoute: typeof PartsNewRoute
  PartsIndexRoute: typeof PartsIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  PartsPartIdEditRoute: typeof PartsPartIdEditRoute
  ProjectsProjectIdAssemblyRoute: typeof ProjectsProjectIdAssemblyRoute
  PartsPartIdIndexRoute: typeof PartsPartIdIndexRoute
  ProjectsProjectIdIndexRoute: typeof ProjectsProjectIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/attachment-types': {
      id: '/attachment-types'
      path: '/attachment-types'
      fullPath: '/attachment-types'
      preLoaderRoute: typeof AttachmentTypesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue': {
      id: '/catalogue'
      path: '/catalogue'
      fullPath: '/catalogue'
      preLoaderRoute: typeof CatalogueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/categories': {
      id: '/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof CategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/currencies': {
      id: '/currencies'
      path: '/currencies'
      fullPath: '/currencies'
      preLoaderRoute: typeof CurrenciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/footprints': {
      id: '/footprints'
      path: '/footprints'
      fullPath: '/footprints'
      preLoaderRoute: typeof FootprintsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import-export': {
      id: '/import-export'
      path: '/import-export'
      fullPath: '/import-export'
      preLoaderRoute: typeof ImportExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/labels': {
      id: '/labels'
      path: '/labels'
      fullPath: '/labels'
      preLoaderRoute: typeof LabelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations': {
      id: '/locations'
      path: '/locations'
      fullPath: '/locations'
      preLoaderRoute: typeof LocationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manufacturers': {
      id: '/manufacturers'
      path: '/manufacturers'
      fullPath: '/manufacturers'
      preLoaderRoute: typeof ManufacturersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preferences': {
      id: '/preferences'
      path: '/preferences'
      fullPath: '/preferences'
      preLoaderRoute: typeof PreferencesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/providers': {
      id: '/providers'
      path: '/providers'
      fullPath: '/providers'
      preLoaderRoute: typeof ProvidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scan': {
      id: '/scan'
      path: '/scan'
      fullPath: '/scan'
      preLoaderRoute: typeof ScanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shelf': {
      id: '/shelf'
      path: '/shelf'
      fullPath: '/shelf'
      preLoaderRoute: typeof ShelfRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers': {
      id: '/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof SuppliersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/units': {
      id: '/units'
      path: '/units'
      fullPath: '/units'
      preLoaderRoute: typeof UnitsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalogue/': {
      id: '/catalogue/'
      path: '/'
      fullPath: '/catalogue/'
      preLoaderRoute: typeof CatalogueIndexRouteImport
      parentRoute: typeof CatalogueRoute
    }
    '/catalogue/$kind': {
      id: '/catalogue/$kind'
      path: '/$kind'
      fullPath: '/catalogue/$kind'
      preLoaderRoute: typeof CatalogueKindRouteImport
      parentRoute: typeof CatalogueRoute
    }
    '/locations/': {
      id: '/locations/'
      path: '/'
      fullPath: '/locations/'
      preLoaderRoute: typeof LocationsIndexRouteImport
      parentRoute: typeof LocationsRoute
    }
    '/locations/$locationId': {
      id: '/locations/$locationId'
      path: '/$locationId'
      fullPath: '/locations/$locationId'
      preLoaderRoute: typeof LocationsLocationIdRouteImport
      parentRoute: typeof LocationsRoute
    }
    '/locations/manage': {
      id: '/locations/manage'
      path: '/manage'
      fullPath: '/locations/manage'
      preLoaderRoute: typeof LocationsManageRouteImport
      parentRoute: typeof LocationsRoute
    }
    '/parts/': {
      id: '/parts/'
      path: '/parts'
      fullPath: '/parts/'
      preLoaderRoute: typeof PartsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parts/new': {
      id: '/parts/new'
      path: '/parts/new'
      fullPath: '/parts/new'
      preLoaderRoute: typeof PartsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shelf/': {
      id: '/shelf/'
      path: '/'
      fullPath: '/shelf/'
      preLoaderRoute: typeof ShelfIndexRouteImport
      parentRoute: typeof ShelfRoute
    }
    '/shelf/recent': {
      id: '/shelf/recent'
      path: '/recent'
      fullPath: '/shelf/recent'
      preLoaderRoute: typeof ShelfRecentRouteImport
      parentRoute: typeof ShelfRoute
    }
    '/shelf/scan': {
      id: '/shelf/scan'
      path: '/scan'
      fullPath: '/shelf/scan'
      preLoaderRoute: typeof ShelfScanRouteImport
      parentRoute: typeof ShelfRoute
    }
    '/parts/$partId/': {
      id: '/parts/$partId/'
      path: '/parts/$partId'
      fullPath: '/parts/$partId/'
      preLoaderRoute: typeof PartsPartIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parts/$partId/edit': {
      id: '/parts/$partId/edit'
      path: '/parts/$partId/edit'
      fullPath: '/parts/$partId/edit'
      preLoaderRoute: typeof PartsPartIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/': {
      id: '/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof ProjectsProjectIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/assembly': {
      id: '/projects/$projectId/assembly'
      path: '/projects/$projectId/assembly'
      fullPath: '/projects/$projectId/assembly'
      preLoaderRoute: typeof ProjectsProjectIdAssemblyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shelf/drawer/$locationId': {
      id: '/shelf/drawer/$locationId'
      path: '/drawer/$locationId'
      fullPath: '/shelf/drawer/$locationId'
      preLoaderRoute: typeof ShelfDrawerLocationIdRouteImport
      parentRoute: typeof ShelfRoute
    }
  }
}

interface CatalogueRouteChildren {
  CatalogueKindRoute: typeof CatalogueKindRoute
  CatalogueIndexRoute: typeof CatalogueIndexRoute
}

const CatalogueRouteChildren: CatalogueRouteChildren = {
  CatalogueKindRoute: CatalogueKindRoute,
  CatalogueIndexRoute: CatalogueIndexRoute,
}

const CatalogueRouteWithChildren = CatalogueRoute._addFileChildren(
  CatalogueRouteChildren,
)

interface LocationsRouteChildren {
  LocationsLocationIdRoute: typeof LocationsLocationIdRoute
  LocationsManageRoute: typeof LocationsManageRoute
  LocationsIndexRoute: typeof LocationsIndexRoute
}

const LocationsRouteChildren: LocationsRouteChildren = {
  LocationsLocationIdRoute: LocationsLocationIdRoute,
  LocationsManageRoute: LocationsManageRoute,
  LocationsIndexRoute: LocationsIndexRoute,
}

const LocationsRouteWithChildren = LocationsRoute._addFileChildren(
  LocationsRouteChildren,
)

interface ShelfRouteChildren {
  ShelfRecentRoute: typeof ShelfRecentRoute
  ShelfScanRoute: typeof ShelfScanRoute
  ShelfIndexRoute: typeof ShelfIndexRoute
  ShelfDrawerLocationIdRoute: typeof ShelfDrawerLocationIdRoute
}

const ShelfRouteChildren: ShelfRouteChildren = {
  ShelfRecentRoute: ShelfRecentRoute,
  ShelfScanRoute: ShelfScanRoute,
  ShelfIndexRoute: ShelfIndexRoute,
  ShelfDrawerLocationIdRoute: ShelfDrawerLocationIdRoute,
}

const ShelfRouteWithChildren = ShelfRoute._addFileChildren(ShelfRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  AttachmentTypesRoute: AttachmentTypesRoute,
  CatalogueRoute: CatalogueRouteWithChildren,
  CategoriesRoute: CategoriesRoute,
  CurrenciesRoute: CurrenciesRoute,
  FootprintsRoute: FootprintsRoute,
  ImportExportRoute: ImportExportRoute,
  LabelsRoute: LabelsRoute,
  LocationsRoute: LocationsRouteWithChildren,
  ManufacturersRoute: ManufacturersRoute,
  PreferencesRoute: PreferencesRoute,
  ProvidersRoute: ProvidersRoute,
  ScanRoute: ScanRoute,
  SettingsRoute: SettingsRoute,
  ShelfRoute: ShelfRouteWithChildren,
  SuppliersRoute: SuppliersRoute,
  UnitsRoute: UnitsRoute,
  PartsNewRoute: PartsNewRoute,
  PartsIndexRoute: PartsIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  PartsPartIdEditRoute: PartsPartIdEditRoute,
  ProjectsProjectIdAssemblyRoute: ProjectsProjectIdAssemblyRoute,
  PartsPartIdIndexRoute: PartsPartIdIndexRoute,
  ProjectsProjectIdIndexRoute: ProjectsProjectIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
